
import React from "react";
import ReactDOM from "react-dom/client";
import MainPage from "./MainPage";

const container = document.getElementById("play-connect");

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <MainPage />
  </React.StrictMode>
);
